<template>
  <VouchersForm />
</template>

<script>
import VouchersForm from '@/layouts/components/form/VoucherForm.vue'

export default {
  components: { VouchersForm },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
